<main>
    <div class="home-main-banner-container">

        <app-carousel [banners]="siteConfig.banners"></app-carousel>
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-search-container">
                    <app-search
                        class="search-home"
                        [ngStyle]="{'background-color': browserHelper.convertToRgbA(siteConfig.siteBackgroundSearchFormColor, 0.7)}"
                        [secondaryColor]="siteConfig.siteBackgroundSearchButtonColor"
                        [searchButtonText]="siteConfig.siteSearchButtonText"></app-search>
                </div>
            </div>
        </div>
        <app-stopwatch-guanabara style="background-color:#f2f4f6"></app-stopwatch-guanabara>


    </div>
    <app-features [features]="siteConfig.features"></app-features>
  
    <app-cookie-consent-modal></app-cookie-consent-modal>
    <div class="home-company-offers">
        <app-owl-carousel [categories]="siteConfig.categories"></app-owl-carousel>
    </div>

    <div class="container">
        <div class="row">
            <div class="col">
                <div class="latest-searches">
                    <div class="row" *ngIf="recentTrips.length > 0">
                        <div class="col-md-12">
                            <h2 class="latest-searches-title">Suas últimas pesquisas</h2>
                            <div class="search-list">
                                <div (click)="onRecentTripSelected(trip)" *ngFor="let trip of recentTrips"
                                    class="search">
                                    <span class="search-text-block"
                                        title="{{trip.departureLocationCode}}">{{trip.departureLocationCode}}</span>
                                    <i class="far fa-chevron-right icon-arrow"></i>
                                    <span class="search-text-block"
                                        title="{{trip.arrivalLocationCode}}">{{trip.arrivalLocationCode}}</span>
                                    <i (click)="onRecentTripRemoved(trip)" class="fas fa-times-circle icon-remove"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-site-tripbanner [tripBanners]="siteConfig.tripBanners"></app-site-tripbanner>
    </div>
</main>